/**
 * Есть ли в этапе видимые подэтапы?
 * @param item
 * @returns {boolean}
 */
export function stageHasVisibleChild(item) {
  if (!item || !item.CHILD) {
    return false;
  }

  return !!item.CHILD.find((child) => child.IS_HIDE != true);
}

/**
 * Применить функцию к корневому этапу и его видимым подэтапам
 * @param item
 * @param fn
 */
export function applyToSubtree(item, fn) {
  fn(item);
  for (const child of item.CHILD) {
    if (child.IS_HIDE) {
      continue;
    }

    applyToSubtree(child, fn);
  }
}

/**
 * Получить все элементы UF_ISTOCHNIK_ID из этапа и его подэтапов
 * @param item
 * @returns {*[]}
 */
export function getSubtreeSourceIds(item) {
  let sourceIds = [];

  if (stageHasVisibleChild(item)) {
    // Если это этап с подэтапами, то источники определяются его подэтапами

    for (const child of item.CHILD) {
      if (child.IS_HIDE) {
        continue;
      }

      sourceIds = sourceIds.concat(getSubtreeSourceIds(child));
    }
  } else {
    sourceIds = sourceIds.concat(item.UF_ISTOCHNIK_ID);
  }

  return sourceIds;
}
